import Vue from 'vue';

export default {
  state: {
    contacts: [],
  },
  mutations: {
    setContacts(state, data) {
      state.contacts = data;
    },
  },
  actions: {
    getContacts(store) {
      const path = 'contacts';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setContacts', resp.data);
        return resp.data;
      });
    },
  },
};
